import React from 'react';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';

import UniPng from 'img-src/uni.png';

import Popper from 'ha/ui/next/Popper';
import PartnerPreview from './PartnerPreview';
import { MapProps, UniMarker } from './Types';
import { MARKER_ZINDEX, MARKER_HOVERED_ZINDEX } from './constants';

const useStyles = makeStyles(() => ({
  pin: {
    position: 'absolute',
    left: 0,
    top: 0,
    cursor: 'pointer',
    transform: 'translateX(-50%) translateY(-100%)',
    zIndex: MARKER_ZINDEX,
  },
  pinHovered: {
    zIndex: MARKER_HOVERED_ZINDEX,
  },
  img: {
    transformOrigin: 'center bottom',
    transition:
      '-webkit-transform 0.25s cubic-bezier(0.485, 1.65, 0.545, 0.835)',
    transform: 'scale(0.5)',
  },
  imgHovered: {
    transform: 'scale(1)',
  },
}));

interface Props {
  marker: UniMarker;
  lat: number;
  lng: number;
  boundariesElement: HTMLElement | null;
}

export const PartnerMarker: React.FC<Props & Partial<MapProps>> = ({
  marker,
  $hover,
  boundariesElement,
}) => {
  const classes = useStyles();

  return (
    <div title={marker.name}>
      <Popper
        anchor={
          <div className={cx(classes.pin, $hover && classes.pinHovered)}>
            <img
              alt={marker.name}
              src={UniPng}
              className={cx(classes.img, $hover && classes.imgHovered)}
            />
          </div>
        }
        modifiers={{
          preventOverflow: {
            enabled: true,
            boundariesElement: boundariesElement || 'window',
          },
        }}
      >
        {() => <PartnerPreview university={marker} />}
      </Popper>
    </div>
  );
};

export default PartnerMarker;
